import PageOne from "./Pages/PageOne";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primeicons/primeicons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Router from "./Pages/Router";

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
